import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const ItalicsIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M4 0V2H6.58L2.92 10H0V12H8V10H5.42L9.08 2H12V0H4Z" />
    </SvgIcon>
  );
};
